import { FC } from 'react'
import { Form, FormType } from './form/Form'
import { AnswerList, AnswerListType } from './List'
import { AnswerCard, AnswerCardType } from './Card'
import { Analytics, AnalyticsType } from './Analytics'
import { AnswerItem, AnswerItemType } from './Item'

export const Answer: FC &
  FormType &
  AnswerListType &
  AnswerCardType &
  AnalyticsType &
  AnswerItemType = (): JSX.Element => <></>

Answer.Form = Form
Answer.List = AnswerList
Answer.Card = AnswerCard
Answer.Analytics = Analytics
Answer.Item = AnswerItem
